<div id="router-outlet">
  <router-outlet></router-outlet>

  <app-global-loader></app-global-loader>
</div>
